import { TextLink } from "@/src/components/links/components/TextLink";
import { TextLinkType } from "@/src/components/links/types";
import { IconContainer, IconSize } from "nvs-design-system/dist/IconContainer";
import { ArrowUpRight } from "nvs-ds-icons";
import { useTokenTransferAnalytics } from "../hooks/analytics";

export default function FAQsLink() {
  const sendAnalytics = useTokenTransferAnalytics();

  return (
    <TextLink
      href="https://www.nike.com/help/a/transfer-nvc"
      className="flex flex-row gap-1 items-center text-sm font-medium normal-case"
      target="_blank"
      linkType={TextLinkType.default}
      onClick={() => {
        sendAnalytics.tokenTransferFAQsClicked({});
      }}
    >
      <span>FAQs</span>
      <IconContainer size={IconSize.sm}>
        <ArrowUpRight />
      </IconContainer>
    </TextLink>
  );
}
